import yup from "./yup-extended";

export const ConsentOrdersUserDetailsSchema = yup
  .object()
  .shape({
    user: yup
      .object()
      .shape({
        first_name: yup.string().required("Required").capitalize(),
        last_name: yup.string().required("Required").capitalize(),
        gender: yup.string().required("Required").nullable(),
        job: yup.string().required("Required"),
        line1_address: yup.string().required("Required"),
        suburb: yup.string().required("Required"),
        state: yup.string().required("Required"),
        postcode: yup.string().required("Required"),
        overseas_state: yup.string().when(["state"], {
          is: (state: string) => state === "overseas",
          then: () => yup.string().required("Required").capitalize().nullable(),
          otherwise: () => yup.string()
        }),
        overseas_country: yup.string().when(["state"], {
          is: (state: string) => state === "overseas",
          then: () => yup.string().required("Required").nullable(),
          otherwise: () => yup.string()
        }),
        dob: yup.string().required("Required").nullable(),
        birth_country: yup.string().required("Required"),
        mobile: yup.string().required("Required"),
        email: yup.string().required("Required"),
        // comments relationship
        comments_relationship: yup.string().notRequired()
      })
      .required()
  })
  .required();

export const ConsentOrdersPartnerDetailsSchema = yup
  .object()
  .shape({
    spouse: yup
      .object()
      .shape({
        first_name: yup.string().capitalize().required("Required"),
        last_name: yup.string().capitalize().required("Required"),
        gender: yup.string().required("Required").nullable(),
        job: yup.string().required("Required"),
        line1_address: yup.string().required("Required"),
        suburb: yup.string().required("Required"),
        state: yup.string().required("Required"),
        postcode: yup.string().required("Required"),

        overseas_state: yup.string().when(["state"], {
          is: (state: string) => state === "overseas",
          then: () => yup.string().capitalize().required("Required").nullable(),
          otherwise: () => yup.string()
        }),
        overseas_country: yup.string().when(["state"], {
          is: (state: string) => state === "overseas",
          then: () => yup.string().required("Required").nullable(),
          otherwise: () => yup.string()
        }),
        dob: yup.string().required("Required"),
        birth_country: yup.string().required("Required"),
        mobile: yup.string().required("Required"),
        email: yup.string().required("Required")
      })
      .required()
  })
  .required();

export const ConsentOrdersRelationshipSchema = yup
  .object()
  .shape({
    relationship: yup
      .object()
      .shape({
        living_date: yup.string().required("Required").nullable(),
        separation_date: yup.string().required("Required").nullable(),
        if_married: yup.string().required("Required").nullable(),
        marriage_date: yup.string().when(["if_married"], {
          is: (if_married: string) => if_married === "yes",
          then: () => yup.string().required("Required").nullable(),
          otherwise: () => yup.string()
        }),
        marriage_city: yup.string().when(["if_married"], {
          is: (if_married: string) => if_married === "yes",
          then: () => yup.string().capitalize().required("Required"),
          otherwise: () => yup.string()
        }),
        marriage_country: yup.string().when(["if_married"], {
          is: (if_married: string) => if_married === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        if_divorced: yup.string().when(["if_married"], {
          is: (if_married: string) => if_married === "yes",
          then: () => yup.string().required("Required").nullable(),
          otherwise: () => yup.string()
        }),
        divorce_date: yup.string().when(["if_divorced"], {
          is: (if_divorced: string) => if_divorced === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        divorce_city: yup.string().when(["if_divorced"], {
          is: (if_divorced: string) => if_divorced === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        divorce_country: yup.string().when(["if_divorced"], {
          is: (if_divorced: string) => if_divorced === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersChildrenSchema = yup
  .object()
  .shape({
    children: yup
      .object()
      .shape({
        if_children: yup.string().required("Required").nullable(),
        child: yup
          .array()
          .when(["if_children"], {
            is: (if_children: string) => if_children === "yes",
            then: () =>
              yup
                .array()
                .of(
                  yup.object().shape({
                    first_name: yup.string().capitalize().required("Required"),
                    last_name: yup.string().capitalize().required("Required"),
                    gender: yup.string().required("Required").nullable(),
                    dob: yup.string().required("Required"),
                    caregiver: yup.string().required("Required"),
                    other_caregiver: yup.object().when(["caregiver"], {
                      is: (caregiver: string) => caregiver === "other",
                      then: () =>
                        yup.object().shape({
                          first_name: yup.string().capitalize().required("Required"),
                          last_name: yup.string().capitalize().required("Required")
                        }),
                      otherwise: () => yup.object()
                    })
                  })
                )
                .required("required")
          })
          .required()
      })
      .required()
  })
  .required();

export const ConsentOrdersChildrenLivingArrangementsSchema = yup
  .object()
  .shape({
    children: yup
      .object()
      .shape({
        if_live_with_anyone: yup.string().required("Required").nullable(),
        live_with: yup
          .array()
          .when(["if_live_with_anyone"], {
            is: (if_live_with_anyone: string) => if_live_with_anyone === "yes",
            then: () =>
              yup
                .array()
                .of(
                  yup.object().shape({
                    first_name: yup.string().capitalize().required("Required"),
                    last_name: yup.string().capitalize().required("Required"),
                    gender: yup.string().required("Required").nullable(),
                    age: yup
                      .string()
                      .required("Required")
                      .matches(/^[0-9]+$/, "Must be only digits"),
                    relation_to_child: yup.string().capitalize().required("Required")
                  })
                )
                .required("required"),
            otherwise: () => yup.array()
          })
          .required(),
        if_live_with_anyone_at_spouse: yup.string().required("Required").nullable(),
        live_with_at_spouse: yup
          .array()
          .when(["if_live_with_anyone_at_spouse"], {
            is: (if_live_with_anyone_at_spouse: string) => if_live_with_anyone_at_spouse === "yes",
            then: () =>
              yup
                .array()
                .of(
                  yup.object().shape({
                    first_name: yup.string().required("Required"),
                    last_name: yup.string().required("Required"),
                    gender: yup.string().required("Required").nullable(),
                    age: yup.string().integer(),
                    relation_to_child: yup.string().required("Required")
                  })
                )
                .required("required"),
            otherwise: () => yup.array()
          })
          .required()
      })
      .required()
  })
  .required();

export const ConsentOrdersYourIncomeSchema = yup
  .object()
  .shape({
    user: yup
      .object()
      .shape({
        user_income_now: yup.string().required("Required").integer(),
        affect_earning_user: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        affect_earning_user_details: yup.string().when(["affect_earning_user"], {
          is: (affect_earning_user: string) => affect_earning_user === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        user_if_paying_cs: yup.string().required("Required").defined(),
        user_cs_payment_to: yup.string().when(["user_if_paying_cs"], {
          is: (user_if_paying_cs: string) => user_if_paying_cs === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        user_cs_payment_amount: yup.string().when(["user_if_paying_cs"], {
          is: (user_if_paying_cs: string) => user_if_paying_cs === "yes",
          then: () => yup.string().required("Required").integer(),
          otherwise: () => yup.string()
        }),
        user_cs_payment_other: yup.object().when(["user_cs_payment_to"], {
          is: (user_cs_payment_to: string) => user_cs_payment_to === "other",
          then: () =>
            yup.object().shape({
              first_name: yup.string().required("Required"),
              last_name: yup.string().required("Required")
            }),
          otherwise: () => yup.object()
        }),

        user_if_receiving_cs: yup.string().required("Required").defined(),
        user_cs_receiving_from: yup.string().when(["user_if_receiving_cs"], {
          is: (user_if_receiving_cs: string) => user_if_receiving_cs === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        user_cs_receiving_amount: yup.string().when(["user_if_receiving_cs"], {
          is: (user_if_receiving_cs: string) => user_if_receiving_cs === "yes",
          then: () => yup.string().required("Required").integer(),
          otherwise: () => yup.string()
        }),
        user_cs_receiving_from_other: yup.object().when(["user_cs_receiving_from"], {
          is: (user_cs_receiving_from: string) => user_cs_receiving_from === "other",
          then: () =>
            yup.object().shape({
              first_name: yup.string().required("Required"),
              last_name: yup.string().required("Required")
            }),
          otherwise: () => yup.object()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersPartnerIncomeSchema = yup
  .object()
  .shape({
    spouse: yup
      .object()
      .shape({
        spouse_income_now: yup.string().required("Required").integer(),
        affect_earning_spouse: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        affect_earning_spouse_details: yup.string().when(["affect_earning_spouse"], {
          is: (affect_earning_spouse: string) => affect_earning_spouse === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        spouse_if_paying_cs: yup.string().required("Required").defined(),
        spouse_cs_payment_to: yup.string().when(["spouse_if_paying_cs"], {
          is: (spouse_if_paying_cs: string) => spouse_if_paying_cs === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        spouse_cs_payment_amount: yup.string().when(["spouse_if_paying_cs"], {
          is: (spouse_if_paying_cs: string) => spouse_if_paying_cs === "yes",
          then: () => yup.string().required("Required").integer(),
          otherwise: () => yup.string()
        }),
        spouse_cs_payment_other: yup.object().when(["spouse_cs_payment_to"], {
          is: (spouse_cs_payment_to: string) => spouse_cs_payment_to === "other",
          then: () =>
            yup.object().shape({
              first_name: yup.string().required("Required"),
              last_name: yup.string().required("Required")
            }),
          otherwise: () => yup.object()
        }),

        spouse_if_receiving_cs: yup.string().required("Required").defined(),
        spouse_cs_receiving_from: yup.string().when(["spouse_if_receiving_cs"], {
          is: (spouse_if_receiving_cs: string) => spouse_if_receiving_cs === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        spouse_cs_receiving_amount: yup.string().when(["spouse_if_receiving_cs"], {
          is: (spouse_if_receiving_cs: string) => spouse_if_receiving_cs === "yes",
          then: () => yup.string().required("Required").integer(),
          otherwise: () => yup.string()
        }),

        spouse_cs_receiving_from_other: yup.object().when(["spouse_cs_receiving_from"], {
          is: (spouse_cs_receiving_from: string) => spouse_cs_receiving_from === "other",
          then: () =>
            yup.object().shape({
              first_name: yup.string().required("Required"),
              last_name: yup.string().required("Required")
            }),
          otherwise: () => yup.object()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersFinancialContributionsSchema = yup
  .object()
  .shape({
    contributions: yup
      .object()
      .shape({
        financial_equal: yup.string().required("Required").defined(),
        financial_contribution: yup.string().when(["financial_equal"], {
          is: (financial_equal: string) => financial_equal === "no",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        financial_not_equal_comments: yup.string().when(["financial_equal"], {
          is: (financial_equal: string) => financial_equal === "no",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersParentingSchema = ({ children }: any) => {
  return yup
    .object()
    .shape({
      contributions: yup
        .object()
        .shape({
          homemaker_contribution_equal: yup.string().required("Required").defined(),
          contribution_chores: yup.string().when(["homemaker_contribution_equal"], {
            is: (homemaker_contribution_equal: string) => homemaker_contribution_equal === "no",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          contribution_chores_comments: yup.string().when(["homemaker_contribution_equal"], {
            is: (homemaker_contribution_equal: string) => homemaker_contribution_equal === "no",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          parenting_contribution_equal:
            children?.if_children === "yes" ? yup.string().required("Required").defined() : yup.string().notRequired(),
          contribution_children_caring: yup.string().when(["parenting_contribution_equal"], {
            is: (parenting_contribution_equal: string) => parenting_contribution_equal === "no",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          contribution_children_caring_comments: yup.string().when(["parenting_contribution_equal"], {
            is: (parenting_contribution_equal: string) => parenting_contribution_equal === "no",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          })
        })
        .required()
    })
    .required();
};

export const ConsentOrdersNonFinancialSchema = yup
  .object()
  .shape({
    contributions: yup
      .object()
      .shape({
        contribution_non_financial_equal: yup.string().required("Required").defined(),
        contribution_non_financial: yup.string().when(["contribution_non_financial_equal"], {
          is: (contribution_non_financial_equal: string) => contribution_non_financial_equal === "no",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        contribution_non_financial_comments: yup.string().when(["contribution_non_financial_equal"], {
          is: (contribution_non_financial_equal: string) => contribution_non_financial_equal === "no",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersSpecialPaymentSchema = yup
  .object()
  .shape({
    contributions: yup
      .object()
      .shape({
        significant_gifts: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        significant_gifts_details: yup.string().when(["significant_gifts"], {
          is: (significant_gifts: string) => significant_gifts === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        inheritance: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        inheritance_details: yup.string().when(["inheritance"], {
          is: (inheritance: string) => inheritance === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        personal_injury: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        personal_injury_details: yup.string().when(["personal_injury"], {
          is: (personal_injury: string) => personal_injury === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        workers_comp: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        workers_comp_details: yup.string().when(["workers_comp"], {
          is: (workers_comp: string) => workers_comp === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        redundancy: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        redundancy_details: yup.string().when(["redundancy"], {
          is: (redundancy: string) => redundancy === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        winnings: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        winnings_details: yup.string().when(["winnings"], {
          is: (winnings: string) => winnings === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        welfare_other_children: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        welfare_other_children_details: yup.string().when(["welfare_other_children"], {
          is: (welfare_other_children: string) => welfare_other_children === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        }),
        other_payments: yup.string().oneOf(["yes", "no"]).required("Required").defined(),
        other_payments_details: yup.string().when(["other_payments"], {
          is: (other_payments: string) => other_payments === "yes",
          then: () => yup.string().required("Required"),
          otherwise: () => yup.string()
        })
      })
      .required()
  })
  .required();

export const ConsentOrdersFutureNeedsSchema = ({ children }: any) => {
  return yup
    .object()
    .shape({
      future_needs: yup
        .object()
        .shape({
          acquired_or_disposed: yup.string().required("Required").defined(),
          acquired_or_disposed_details: yup.string().when(["acquired_or_disposed"], {
            is: (acquired_or_disposed: string) => acquired_or_disposed === "yes",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          health_issues: yup.string().required("Required").defined(),
          health_issues_details: yup.string().when(["health_issues"], {
            is: (health_issues: string) => health_issues === "yes",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          earning_less_potential: yup.string().required("Required").defined(),
          earning_less_potential_details: yup.string().when(["earning_less_potential"], {
            is: (earning_less_potential: string) => earning_less_potential === "yes",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          requalify_work: yup.string().required("Required").defined(),
          requalify_work_details: yup.string().when(["requalify_work"], {
            is: (requalify_work: string) => requalify_work === "yes",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          new_relationship: yup.string().required("Required").defined(),
          new_relationship_details: yup.string().when(["new_relationship"], {
            is: (new_relationship: string) => new_relationship === "yes",
            then: () => yup.string().required("Required"),
            otherwise: () => yup.string()
          }),
          primary_caregiver_after_separation:
            children?.if_children === "yes" ? yup.string().required("Required") : yup.string()
        })
        .required()
    })
    .required();
};

export const ConsentOrdersFinancialResourcesSchema = yup
  .object()
  .shape({
    financial_resources: yup
      .object()
      .shape({
        employment_entitlements: yup.string().required("Required").defined(),
        employment_entitlements_details: yup.string().when(["employment_entitlements"], {
          is: (employment_entitlements: string) => employment_entitlements === "yes",
          then: () => yup.string().required("Required").defined(),
          otherwise: () => yup.string()
        }),
        payout_future: yup.string().required("Required").defined(),
        payout_future_details: yup.string().when(["payout_future"], {
          is: (payout_future: string) => payout_future === "yes",
          then: () => yup.string().required("Required").defined(),
          otherwise: () => yup.string()
        }),
        if_unpaid_inheritance: yup.string().required("Required").defined(),
        unpaid_inheritance_details: yup.string().when(["if_unpaid_inheritance"], {
          is: (if_unpaid_inheritance: string) => if_unpaid_inheritance === "yes",
          then: () => yup.string().required("Required").defined(),
          otherwise: () => yup.string()
        }),
        beneficiary_trust: yup.string().required("Required").defined(),
        beneficiary_trust_details: yup.string().when(["beneficiary_trust"], {
          is: (beneficiary_trust: string) => beneficiary_trust === "yes",
          then: () => yup.string().required("Required").defined(),
          otherwise: () => yup.string()
        }),
        cash_life_insurance: yup.string().required("Required").defined(),
        cash_life_insurance_details: yup.string().when(["cash_life_insurance"], {
          is: (cash_life_insurance: string) => cash_life_insurance === "yes",
          then: () => yup.string().required("Required").defined(),
          otherwise: () => yup.string()
        })
      })
      .required()
  })
  .required();
